/* tslint:disable */
/* eslint-disable */
/**
 * TurboClaim API
 * TurboClaim API for insurance claim management. Includes claims, documents, estimates, supplements, billing, and chat operations. Authentication is JWT-based bearer token. 
 *
 * The version of the OpenAPI document: 1.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Request to update an existing claim pipeline
 * @export
 * @interface UpdateClaimPipelineRequest
 */
export interface UpdateClaimPipelineRequest {
    /**
     * Pipeline name
     * @type {string}
     * @memberof UpdateClaimPipelineRequest
     */
    name?: string;
    /**
     * Optional description of the pipeline
     * @type {string}
     * @memberof UpdateClaimPipelineRequest
     */
    description?: string | null;
    /**
     * Optional hex color code for pipeline display (e.g., "#3B82F6")
     * @type {string}
     * @memberof UpdateClaimPipelineRequest
     */
    color?: string | null;
    /**
     * Order in which pipelines should be displayed
     * @type {number}
     * @memberof UpdateClaimPipelineRequest
     */
    displayOrder?: number;
    /**
     * Whether this pipeline is active
     * @type {boolean}
     * @memberof UpdateClaimPipelineRequest
     */
    isActive?: boolean;
}

/**
 * Check if a given object implements the UpdateClaimPipelineRequest interface.
 */
export function instanceOfUpdateClaimPipelineRequest(value: object): value is UpdateClaimPipelineRequest {
    return true;
}

export function UpdateClaimPipelineRequestFromJSON(json: any): UpdateClaimPipelineRequest {
    return UpdateClaimPipelineRequestFromJSONTyped(json, false);
}

export function UpdateClaimPipelineRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateClaimPipelineRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'] == null ? undefined : json['name'],
        'description': json['description'] == null ? undefined : json['description'],
        'color': json['color'] == null ? undefined : json['color'],
        'displayOrder': json['displayOrder'] == null ? undefined : json['displayOrder'],
        'isActive': json['isActive'] == null ? undefined : json['isActive'],
    };
}

export function UpdateClaimPipelineRequestToJSON(json: any): UpdateClaimPipelineRequest {
    return UpdateClaimPipelineRequestToJSONTyped(json, false);
}

export function UpdateClaimPipelineRequestToJSONTyped(value?: UpdateClaimPipelineRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
        'description': value['description'],
        'color': value['color'],
        'displayOrder': value['displayOrder'],
        'isActive': value['isActive'],
    };
}

